import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import PDThemeProvider from './components/PDThemeProvider';

import RoutesWrapper from './RoutesWrapper';

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Router>
                <AuthProvider>
                    <PDThemeProvider>
                        <RoutesWrapper />
                    </PDThemeProvider>
                </AuthProvider>
            </Router>
        </LocalizationProvider>
    );
}

export default App;
